import { render, staticRenderFns } from "./examen-preview-result.html?vue&type=template&id=20c468b2&scoped=true&external"
import script from "./examen-preview-result.js?vue&type=script&lang=js&external"
export * from "./examen-preview-result.js?vue&type=script&lang=js&external"
import style0 from "./examen-preview-result.scss?vue&type=style&index=0&id=20c468b2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c468b2",
  null
  
)

export default component.exports